export default __webpack_public_path__ + "static/media/chat-icon2.7150b285.svg";